import { ErroreApi } from '../api/cliente.js';
import { type Sessione, useScegliAzienda, useUscita } from '../api/sessione.js';
import { CorniceIngresso } from '../componenti/CorniceIngresso.js';
import { t } from '../i18n/lingua.js';
import marchioSpa from '../immagini/la-regina-san-marzano.webp';
import marchioInc from '../immagini/la-regina-san-marzano-usa.webp';

/**
 * Il logo di ogni azienda, come nel v2: la Spa ha quello di San Marzano, la
 * Inc lo stesso con «USA». Un'azienda che qui non c'è si riconosce dalla
 * sigla.
 */
const MARCHI: Record<string, string> = {
  SPA: marchioSpa,
  INC: marchioInc,
};

/**
 * Scelta dell'azienda, per chi ne ha più di una.
 *
 * Compare solo quando serve: chi lavora in una sola società entra diretto e
 * questa schermata non la vede mai.
 */
export function ScegliAzienda({ sessione }: { sessione: Sessione }) {
  const scegli = useScegliAzienda();
  const uscita = useUscita();
  const errore = scegli.error instanceof ErroreApi ? scegli.error : null;

  return (
    <CorniceIngresso>
      <div className="ingresso-schermata">
        <header className="ingresso-intesta">
          <h1 className="ingresso-titolo">{t('Con quale azienda lavori?')}</h1>
          <p className="ingresso-sotto">
            {t('Ciao {nome}, puoi cambiarla quando vuoi.', { nome: sessione.user.name.split(' ')[0] ?? '' })}
          </p>
        </header>

        {errore && (
          <div className="avviso" role="alert" style={{ marginBottom: 12 }}>
            <span className="avviso-segno">▲</span>
            <span>{errore.message}</span>
          </div>
        )}

        <div className="aziende">
          {sessione.user.companies.map((azienda) => {
            const marchio = MARCHI[azienda.code];
            return (
              <button
                key={azienda.id}
                className="azienda-scelta"
                onClick={() => scegli.mutate(azienda.id)}
                disabled={scegli.isPending}
              >
                {marchio ? (
                  <span className="azienda-marchio">
                    <img src={marchio} alt="" />
                  </span>
                ) : (
                  <span className="azienda-sigla">{azienda.code}</span>
                )}
                <span className="azienda-testo">
                  <span className="azienda-nome">{azienda.name}</span>
                  <span className="azienda-codice">{azienda.code}</span>
                </span>
                <span className="azienda-freccia" aria-hidden="true">
                  →
                </span>
              </button>
            );
          })}
        </div>

        <p className="ingresso-indietro">
          {t('Non sei tu?')}{' '}
          <button className="ingresso-link" type="button" onClick={() => uscita.mutate()}>
            {t('Esci')}
          </button>
        </p>
      </div>
    </CorniceIngresso>
  );
}
